import { Link } from 'react-router-dom';
import { Button, Card, EmptyState, PageHeader } from '../components/ui';

export function NotFoundPage() {
  return (
    <div className="space-y-5">
      <PageHeader title="页面不存在" description="地址可能拼错了，或者这个页面已经被移除。" />
      <Card>
        <EmptyState
          icon="search"
          title="找不到这个页面"
          description="如果你是从某个链接点进来的，麻烦把来源告诉我们。"
          action={
            <Link to="/">
              <Button variant="primary">回到概览</Button>
            </Link>
          }
        />
      </Card>
    </div>
  );
}
